import React, { useEffect, useState } from "react";
import { IFilterReport } from "../../../../types/filter.type";
import moment from "moment";
import { ConcernType } from "../../../../types/report.type";
import { numeralCustom } from "../../../../utils/helpers";
import WrapperFilter from "../WrapperFilter";
import { Stack } from "@mui/material";
import FilterRadios from "../FilterRadios";
import FilterTimeFromTo2 from "../FilterTimeFromTo2";

const concerns: ConcernType[] = [
  {
    title: "Thống kê bán vé theo thời gian",
    label: "Thời gian",
    value: "thoigian",
    api: "fos_rptonghopvexe",
    convertData: (data, queryObject) => {
      const result: any[] = [];
      const total = data.pop();
      result.push({
        thoi_gian: `${moment(queryObject?.tu_ngay).format(
          "DD/MM/YYYY"
        )} - ${moment(queryObject?.den_ngay).format("DD/MM/YYYY")}`,
        ...total,
      });
      return result;
    },
    columns: [
      {
        name: "Thời gian",
        width: "300px",
        selector: (row) => row.thoi_gian,
      },
      {
        name: "Tổng số",
        width: "120px",
        center: true,
        selector: (row) => row.t_so_luong,
      },
      {
        name: "Hoàn thành",
        width: "120px",
        center: true,
        selector: (row) => row.sl_used,
      },
      {
        name: "Đặt vé",
        width: "150px",
        center: true,
        selector: (row) => row.sl_pending,
      },
      {
        name: "Đã hủy",
        width: "130px",
        center: true,
        selector: (row) => row.sl_cancel,
      },
      {
        name: "Áp dụng mã",
        width: "120px",
        center: true,
        selector: (row) => row.sl_sd_pos,
      },
      {
        name: "Tiền vé",
        width: "120px",
        right: true,
        selector: (row) => row.tien_hang_nt,
        format: (row) => numeralCustom(row.tien_hang_nt).format(),
      },
      {
        name: "Tiền CK",
        width: "120px",
        right: true,
        selector: (row) => row.tien_ck_nt,
        format: (row) => numeralCustom(row.tien_ck_nt).format(),
      },
      {
        name: "Tổng tiền",
        width: "120px",
        right: true,
        selector: (row) => row.tien_tt_nt,
        format: (row) => numeralCustom(row.tien_tt_nt).format(),
      },
      {
        name: "Nhà xe thu",
        width: "120px",
        right: true,
        selector: (row) => row.tien_nha_xe,
        format: (row) => numeralCustom(row.tien_nha_xe).format(),
      },
      {
        name: "Hoa hồng",
        width: "130px",
        right: true,
        selector: (row) => row.tien_hh,
        format: (row) => numeralCustom(row.tien_hh).format(),
      },
      {
        name: "Trả lại nhà xe",
        width: "130px",
        right: true,
        selector: (row) => row.tien_tt_hang,
        format: (row) => numeralCustom(row.tien_tt_hang).format(),
      },
    ],
  },
  {
    title: "Thống kê vé bán theo nhà xe",
    label: "Nhà xe",
    value: "nhaxe",
    api: "fos_rptonghopvexe",
    convertData: (data) => {
      const result: any[] = [];
      const total = data.pop();
      result.push(total, ...data);
      return result;
    },
    columns: [
      {
        name: "Nhà xe",
        width: "150px",
        selector: (row) => row.ten_nha_xe,
      },
      {
        name: "Tổng số",
        width: "120px",
        center: true,
        selector: (row) => row.t_so_luong,
      },
      {
        name: "Hoàn thành",
        width: "120px",
        center: true,
        selector: (row) => row.sl_used,
      },
      {
        name: "Đặt vé",
        width: "150px",
        center: true,
        selector: (row) => row.sl_pending,
      },
      {
        name: "Đã hủy",
        width: "130px",
        center: true,
        selector: (row) => row.sl_cancel,
      },
      {
        name: "Áp dụng mã",
        width: "120px",
        center: true,
        selector: (row) => row.sl_sd_pos,
      },
      {
        name: "Tiền vé",
        width: "120px",
        right: true,
        selector: (row) => row.tien_hang_nt,
        format: (row) => numeralCustom(row.tien_hang_nt).format(),
      },
      {
        name: "Tiền CK",
        width: "120px",
        right: true,
        selector: (row) => row.tien_ck_nt,
        format: (row) => numeralCustom(row.tien_ck_nt).format(),
      },
      {
        name: "Tổng tiền",
        width: "120px",
        right: true,
        selector: (row) => row.tien_tt_nt,
        format: (row) => numeralCustom(row.tien_tt_nt).format(),
      },
      {
        name: "Nhà xe thu",
        width: "120px",
        right: true,
        selector: (row) => row.tien_nha_xe,
        format: (row) => numeralCustom(row.tien_nha_xe).format(),
      },
      {
        name: "Hoa hồng",
        width: "130px",
        right: true,
        selector: (row) => row.tien_hh,
        format: (row) => numeralCustom(row.tien_hh).format(),
      },
      {
        name: "Trả lại nhà xe",
        width: "130px",
        right: true,
        selector: (row) => row.tien_tt_hang,
        format: (row) => numeralCustom(row.tien_tt_hang).format(),
      },
    ],
  },
];

function FilterRPTTongHopVeXe({ setConcern, setQueryObject }: IFilterReport) {
  const originFilter = {
    timeFrom: moment().startOf("months").format("YYYY-MM-DD"),
    timeTo: moment().endOf("days").format("YYYY-MM-DD"),
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [valueConcern, setValueConcern] = useState(concerns[0].value);
  const [timeOption, setTimeOption] = useState<any>();

  const handleRefreshFilter = () => {
    setFilter(originFilter);
  };

  useEffect(() => {
    const queryObject: { [key: string]: any } = { ma_ct: "pbl_nh" };
    if (filter.timeFrom) {
      queryObject.tu_ngay = moment(filter.timeFrom)
        .startOf("days")
        .toISOString();
    }
    if (filter.timeTo) {
      queryObject.den_ngay = moment(filter.timeTo).endOf("days").toISOString();
    }
    setQueryObject(queryObject);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  useEffect(() => {
    setConcern(concerns.find((item) => item.value === valueConcern));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueConcern, timeOption?.value]);

  return (
    <WrapperFilter refreshFilter={handleRefreshFilter}>
      <Stack sx={{ width: "100%" }} gap={1}>
        <FilterRadios
          title="Thống kê theo"
          values={concerns}
          defaultValue={valueConcern}
          onChange={(newConcern) => setValueConcern(newConcern)}
        />
        <FilterTimeFromTo2
          showOptions
          defaultTimeFrom={filter.timeFrom}
          defaultTimeTo={filter.timeTo}
          title="Thời gian"
          onOptionChange={setTimeOption}
          onSearch={(time) => setFilter({ ...filter, ...time })}
        />
      </Stack>
    </WrapperFilter>
  );
}

export default FilterRPTTongHopVeXe;
